import { isoWeek, isoWeekRange } from "@lovmia/shared";

const monthFormat = new Intl.DateTimeFormat("ru-RU", { day: "numeric", month: "short" });

/** Текущая рабочая неделя: `W32` — тот же номер, что уходит в ad name. */
export function currentWeekLabel(now: Date = new Date()) {
  return `W${isoWeek(now)}`;
}

/** `3–9 авг` — диапазон текущей недели для шапки. */
export function currentWeekRangeLabel(now: Date = new Date()) {
  const { start, end } = isoWeekRange(now);
  const from = monthFormat.format(start).replace(".", "");
  const to = monthFormat.format(end).replace(".", "");
  return start.getMonth() === end.getMonth()
    ? `${start.getDate()}–${to}`
    : `${from} – ${to}`;
}
